/**
 * The `EmptyClass` is to represent the type of class constructors
 */
export class EmptyClass {}
